import React, { useState } from 'react'
import { Modal } from 'antd'
import './index.scss'
import TermsAndCondition from '../TermsAndConditions'

const Footer: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const showModal = () => {
    setIsModalOpen(true)
  }
  const ToggleInfoDisplay = () => {
    ;(window as any)?.OneTrust?.ToggleInfoDisplay()
  }

  const handleOk = () => {
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const handleNoticeClick = () => {
    const v1 = window.open("/license.html", "_blank");
    if (v1 === null) {
      console.error("Failed to open license.html");
    }
  };

  return (
    <div className='copy-right'>
      Copyright © 2024 Deloitte Development LLC. All rights reserved. See
      <a
        href='https://www2.deloitte.com/us/en/footerlinks1/privacy-notice-limited-controller.html'
        target='_blank'
        className='notice-link'
        rel='noreferrer'
      >
        Privacy Policy
      </a>
      ,
      <a className='notice-link' onClick={showModal}>
        Terms of use
      </a>
      <Modal
        style={{ width: '70%' }}
        title='Terms of use'
        open={isModalOpen}
        closable={true}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <TermsAndCondition />
      </Modal>
      ,
      <a
        className='notice-link'
        href='https://cookienotice.deloitte.com'
        target='_blank'
        rel='noreferrer'
      >
        Cookies
      </a>
      ,
      <a className='notice-link' onClick={ToggleInfoDisplay}>
        Cookie Settings
      </a>
      and
      <a
        onClick={handleNoticeClick}
        className='notice-link'
      >
        Notices
      </a>
      for more information.
    </div>
  )
}

export default Footer
